<template>
	<wt-selector :options="options" v-model="Value" :clearable="true" @change="handleChange"></wt-selector>
</template>
<script>
export default {
  name: 'lab-staff-selector',
  props: {
    value: {
      type: String,
      default: ''
    },
    isName:Boolean
  },
  data () {
    return {
      Value: this.value,
      options: []
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    handleChange(val){
      this.$emit('getObj',this.options.find(item=>item.value === val))
    },
    getOptions () {
      let data = {
        role:["ROLE_RT_EX","ROLE_EX"],
        pageable: {
          page: 0,
          size: 99999
        }
      }
      this.$store.dispatch('systemCustomerList', data).then(res => {

        this.options = res.data.map(ele => {
          return {
            label: ele.firstName,
						value: this.isName ? ele.firstName : ele.id,
						signatureImageUrl:ele.signatureImageUrl
          }
        })
        // if (this.options.length === 1) {
        //   this.Value = this.options[0].value
        // }
      })
    }
  },
  created () {
    this.getOptions()
  }
}
</script>
